import { render, staticRenderFns } from "./PurchaseInfosDialog.vue?vue&type=template&id=31dce679&"
import script from "./PurchaseInfosDialog.vue?vue&type=script&lang=ts&"
export * from "./PurchaseInfosDialog.vue?vue&type=script&lang=ts&"
import style0 from "./PurchaseInfosDialog.vue?vue&type=style&index=0&id=31dce679&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports